import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 17 26"
    fill="none"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_4891_3242"
      width={18}
      height={26}
      x={-0.99}
      y={0.078}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M-.99.078h18v26h-18z" />
      <path d="M8.504 23.962c1.286 0 4.628 1.686 6.56-.42 1.546-1.689.975-5.749-.134-8.481-.413-1.017-.327-2.418-.221-3.51.502-5.218.34-9.943-1.389-10.345-1.388-.324-2.496 8.697-4.815 8.697S6.149 1.078 4.37 1.078 1.886 7.174 2.156 11.905c.062 1.095.336 2.139-.076 3.155C.97 17.793.4 21.852 1.947 23.541c1.93 2.107 5.273.42 6.558.42z" />
    </mask>
    <path
      fill={props.fill || '#E4E4E7'}
      d="M8.504 23.962c1.286 0 4.628 1.686 6.56-.42 1.546-1.689.975-5.749-.134-8.481-.413-1.017-.327-2.418-.221-3.51.502-5.218.34-9.943-1.389-10.345-1.388-.324-2.496 8.697-4.815 8.697S6.149 1.078 4.37 1.078 1.886 7.174 2.156 11.905c.062 1.095.336 2.139-.076 3.155C.97 17.793.4 21.852 1.947 23.541c1.93 2.107 5.273.42 6.558.42z"
    />
    <path
      d="M8.50447 23.9623C9.78969 23.9623 13.1323 25.648 15.0632 23.5415C16.6104 21.8534 16.0389 17.7931 14.9301 15.0606C14.5174 14.0442 14.6034 12.6432 14.7085 11.5511C15.2106 6.33266 15.049 1.60832 13.3201 1.20559C11.9317 0.882346 10.8239 9.90305 8.50494 9.90305C6.18602 9.90305 6.14893 1.078 4.37063 1.078C2.59234 1.078 1.88627 7.17432 2.15587 11.9048C2.21815 13.0002 2.49203 14.0437 2.07979 15.0601C0.970967 17.7927 0.399426 21.8524 1.94664 23.541C3.87756 25.6475 7.2202 23.9618 8.50543 23.9618L8.50447 23.9623Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_4891_3242)"
    />
  </svg>
);
export default SvgNormal;
